import { ViewType, ViewObject } from '../base';

import { dataService } from '../../data';
import { FloorArea } from '../objects/floorarea';

import { QrCodeView } from './qrcode';

/****************************/
/* CLASS VIEW               */
/****************************/

export class _FloorAreaView extends ViewObject<FloorArea> {

    /**********************************/
    /* VIEWOBJECT IMPLEMENTATION      */
    /**********************************/

    private get floorarea(): FloorArea {
        return this.object;
    }

    constructor(object: FloorArea, data: dataService){
        super(object, data);
    }

    override OnDestroy(): void {
        super.OnDestroy();
    }

    /**********************************/
    /* VIEW MANAGED INFORMATION       */
    /**********************************/

    private _validtables: QrCodeView[] | null = null;

    private RefreshView(targets: string[]): void {
        if (!targets.includes('QRCODE') && !targets.includes('FLOORAREA') && !targets.includes('DRAWITEM')){
            return;
        }

        this._validtables = null;
        this.DoRefreshView();
    }

    /**********************************/
    /* CHILDREN REGISTRATION          */
    /**********************************/

    override doRegister(): void {
        const weakref = new WeakRef(this);

        for (const _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];

        this._subscriptions.push(
            this.floorarea.OnRefresh.subscribe(
                (targets: string[]) => {
                    const self = weakref.deref();
                    if (self){
                        self.RefreshView(targets);
                    }
                },
            ),
        );

        const _place = this.floorarea.place;
        if (_place){
            this._subscriptions.push(
                _place.OnRefresh.subscribe(
                    (targets: string[]) => {
                        const self = weakref.deref();
                        if (self){
                            self.RefreshView(targets);
                        }
                    },
                ),
            );
        }
    }

    /**********************************/
    /* ACTIVE CHILDREN INFORMATION    */
    /**********************************/

    /** Valid tables assigned to this floor area as canonical QrCode views. */
    get tables(): QrCodeView[] {
        if (this._validtables === null){
            const _tables: QrCodeView[] = [];

            for (const _qrcode of this.floorarea.qrcodes){
                const _view = this.alives.get(_qrcode) as QrCodeView | null;
                if (_view){
                    _tables.push(_view);
                }
            }

            this._validtables = _tables;
        }

        return this._validtables;
    }
}

/****************************/
/* PROXY VIEW               */
/****************************/

export type FloorAreaView = ViewType<_FloorAreaView, FloorArea>;

export function FloorAreaViewProxy(object: FloorArea, data: dataService): FloorAreaView {
    return new _FloorAreaView(object, data).Proxy as FloorAreaView;
}
